export const __APP_STORAGE_CART__ = 'cart';
//export const __APP_COUNT_ITEMS_CART__ = 'cartCounter';
